import DonutChart from "../../../../components/donut/donut";
import { connect } from "react-redux";
export default connect(state => ({
  value: state.attendance.visitsByType.percentageOfNewVisits * 100,
  type: "New",
  dollarValue: state.attendance.visitsByType.newVisits,
  growth: state.attendance.visitsByType.newVisitsPercentChange,
  toolTip: "Percentage Change from previous month"
}))(DonutChart);
